import React from "react";
import { useEffect, useState } from "react";
import axiosClient from "../axios-client.js";
import _ from "lodash";
import moment from "../js/moment-config.js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import swal from "sweetalert";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import RideSeats from "../components/RideSeats";
import TrainSeats from "../components/TrainSeats";
import MindBodySeats from "../components/MindBodySeats";

const DetallesClase = () => {
  const [classDetails, setClass] = useState({
    class: {
      coach_name: "",
    },
    seats: [],
  });
  const [seatDetails, setSeat] = useState(0);

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingRes, setLoadingRes] = useState(false);
  const [membershipModal, setMembershipModal] = useState(false);
  const [membershipType, setMembershipType] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [waitlistPosition, setWaitlistPosition] = useState(null); // null = not in waitlist
  const [loadingWaitlist, setLoadingWaitlist] = useState(false);
  const [showCoachModal, setShowCoachModal] = useState(false);
  const [coaches, setCoaches] = useState([]);
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getClassDetails();
    checkAdminRole();
    getWaitlistPosition();
  }, []);

  const checkAdminRole = () => {
    // ASUMO que el objeto user tiene una propiedad 'role' y que el valor 'admin' lo identifica
    const user = JSON.parse(localStorage.getItem("USER_DATA"));
    if (user && user.role === "admin") {
      setIsAdmin(true);
    } else {
      setIsAdmin(false);
    }
  };
  const handleCancelarClase = () => {
    swal({
      title: "¿Estás seguro de cancelar la clase?",
      text: "Esta acción es irreversible, devolverá los créditos y notificará a los usuarios.",
      icon: "warning",
      buttons: ["No, mantener", "Sí, cancelar"],
      dangerMode: true,
    }).then((willCancel) => {
      if (willCancel) {
        setLoading(true); // O puedes usar un estado de loading dedicado para acciones de admin
        axiosClient
          .post(`/clases/${id}/cancelar`)
          .then(({ data }) => {
            swal("¡Clase Cancelada!", data.message, "success"); // Opcional: Redirigir o recargar la página para ver el cambio de estado
            navigate("/reservar-clases");
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.error ||
              "Hubo un error al cancelar la clase.";
            swal("Error", errorMessage, "error");
          })
          .finally(() => {
            setLoading(false);
          });
      }
    });
  };

  const handleNotificarCoach = () => {
    axiosClient.get("/coaches-active").then(({ data }) => {
      setCoaches(data.data ?? data);
      setSelectedCoachId("");
      setShowCoachModal(true);
    });
  };

  const submitCoachChange = () => {
    if (!selectedCoachId) return;
    setShowCoachModal(false);
    setLoading(true);
    axiosClient
      .post(`/clases/${id}/notificacion-coach`, { coach_id: selectedCoachId })
      .then(({ data }) => {
        swal("¡Listo!", data.message, "success");
        getClassDetails();
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.error || "Hubo un error al cambiar el coach.";
        swal("Error", errorMessage, "error");
      })
      .finally(() => setLoading(false));
  };

  const getClassDetails = () => {
    setLoading(true);
    axiosClient
      .get(`/classes/${id}`)
      .then(({ data }) => {
        setClass(data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getWaitlistPosition = () => {
    const user = JSON.parse(localStorage.getItem("USER_DATA"));
    if (!user) return;
    axiosClient
      .get(`/classes/${id}/waitlist/position`)
      .then(({ data }) => {
        if (data.in_waitlist) {
          setWaitlistPosition(data.position);
        } else {
          setWaitlistPosition(null);
        }
      })
      .catch(() => {});
  };

  const handleJoinWaitlist = () => {
    const user = JSON.parse(localStorage.getItem("USER_DATA"));
    if (!user) {
      swal({
        title: "Error",
        text: "Ocupa crear un usuario y contar con un paquete de clases para poder unirte a la lista de espera",
        icon: "error",
      }).then(() => navigate("/auth/signup"));
      return;
    }
    swal({
      title: "¿Unirte a la lista de espera?",
      text: "Te notificaremos si se libera un lugar. Se descontará 1 crédito si el lugar se libera con más de 5 horas de anticipación.",
      icon: "info",
      buttons: ["Cancelar", "Sí, agregarme"],
    }).then((confirm) => {
      if (!confirm) return;
      setLoadingWaitlist(true);
      axiosClient
        .post(`/classes/${id}/waitlist`)
        .then(({ data }) => {
          setWaitlistPosition(data.position);
          swal("¡Listo!", `Estás en la lista de espera. Posición: ${data.position}`, "success");
        })
        .catch((error) => {
          const msg = error.response?.data?.message || "Hubo un error al unirte a la lista de espera.";
          swal("Error", msg, "error");
        })
        .finally(() => setLoadingWaitlist(false));
    });
  };

  const handleLeaveWaitlist = () => {
    swal({
      title: "¿Salir de la lista de espera?",
      text: "Perderás tu lugar en la fila.",
      icon: "warning",
      buttons: ["No, quedarme", "Sí, salir"],
      dangerMode: true,
    }).then((confirm) => {
      if (!confirm) return;
      setLoadingWaitlist(true);
      axiosClient
        .delete(`/classes/${id}/waitlist`)
        .then(() => {
          setWaitlistPosition(null);
          swal("Listo", "Saliste de la lista de espera.", "success");
        })
        .catch((error) => {
          const msg = error.response?.data?.message || "Hubo un error al salir de la lista de espera.";
          swal("Error", msg, "error");
        })
        .finally(() => setLoadingWaitlist(false));
    });
  };

  const handleClose = () => {
    setSeat(0);
    setShow(false);
  };

  const handleShow = (seat) => {
    setSeat(seat);
    setShow(true);
  };

  const reservarLugar = (seat) => {
    setLoadingRes(true);
    const user = JSON.parse(localStorage.getItem("USER_DATA"));
    if (!user) {
      swal({
        title: "Error",
        text: "Ocupa crear un usuario y contar con un paquete de clases para poder reservar",
        icon: "error",
      }).then(() => {
        navigate("/auth/signup");
      });
    }

    const reservation = {
      class_id: classDetails.class.id,
      user_id: user.id,
      bike_number: seat,
      status: "Reservada",
      validated: 0,
    };

    axiosClient
      .post(`/reservations`, reservation)
      .then(({ data }) => {
        handleClose();

        if (data.used_membership) {
          const labels = {
            ride_membership:  'Membresía Ride',
            train_membership: 'Membresía Train',
            align_membership: 'Membresía Align',
          };
          setMembershipType(labels[data.membership_type] ?? 'membresía');
          setMembershipModal(true);
        } else {
          swal({ title: "Reservacion exitosa", text: "Gracias", icon: "success" });
        }

        const reservationData = data.used_membership ? data.data : data;
        const updatedSeats = classDetails.seats.map((s) => {
          if (s.seat_number === seat) {
            return {
              ...s,
              status: 1,
            };
          }
          return s;
        });
        setClass((prevClass) => ({
          ...prevClass,
          seats: updatedSeats,
        }));
        setLoadingRes(false);
        navigate("/mis-clases");
      })
      .catch((error) => {
        const err = JSON.parse(error.request.response);
        handleClose();
        setLoadingRes(false);
        swal({
          title: "Error",
          text: err.message,
          icon: "error",
        }).then(() => {
          navigate("/reservar-clases");
        });
      });
  };

  return (
    <div className="ps-4 pe-4">
      <div className="mt-5 mb-4">
        <p className="calendario-titulo">Reserva en línea</p>
      </div>

      {loading && !classDetails.class ? (
        <div className="loading-container center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-lg-3 detalle-clase">
            {isAdmin && (
              <div className="mt-4 d-grid gap-2">
                <Button
                  variant="danger"
                  onClick={handleCancelarClase}
                  disabled={loading}
                >
                  Cancelar Clase 🚫
                </Button>
                <Button
                  variant="warning"
                  onClick={handleNotificarCoach}
                  disabled={loading}
                >
                Notificar Cambio de Coach 📣
                </Button>
              </div>
            )}
            {(() => {
              const maxSeat = { Ride: 17, Train: 11 }[classDetails.class.type_class] ?? 7;
              const visibleSeats = classDetails.seats.filter((s) => s.seat_number <= maxSeat);
              const isFull =
                visibleSeats.length > 0 &&
                visibleSeats.every((s) => s.status === 1);
              if (!isFull) return null;
              const user = JSON.parse(localStorage.getItem("USER_DATA"));
              if (!user) return null;
              return (
                <div className="mt-4 d-grid">
                  {waitlistPosition !== null ? (
                    <>
                      <p className="text-center mb-1">
                        <strong>Estás en la lista de espera</strong>
                        <br />
                        <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                          Te notificaremos si se libera un lugar.
                        </span>
                      </p>
                      <Button
                        variant="outline-danger"
                        onClick={handleLeaveWaitlist}
                        disabled={loadingWaitlist}
                      >
                        Salir de lista de espera
                      </Button>
                    </>
                  ) : (
                    <>
                      <p className="text-center mb-1 text-danger">
                        <strong>Clase llena</strong>
                      </p>
                      <Button
                        variant="outline-primary"
                        onClick={handleJoinWaitlist}
                        disabled={loadingWaitlist}
                      >
                        Unirme a lista de espera
                      </Button>
                    </>
                  )}
                </div>
              );
            })()}
            <p>
              <span className="bold">Hora de la clase:</span>{" "}
              {classDetails.class.class_time}
            </p>
            <p>
              <span className="bold">Fecha:</span>{" "}
              {classDetails.class.class_date}
            </p>
            <p>
              <span className="bold">Coach:</span>{" "}
              {classDetails.class.coach_name}
            </p>
            <p>
              <span className="bold">Duración: </span>
              {classDetails.class.duration} Minutos
            </p>
            <p className="texto-bola">
              <span className="bold">Lugares Disponibles:</span>
              <span
                className={`bola-seat info ${
                  classDetails.class.type_class == "Train" ? "bola-roja" : ""
                }`}
              ></span>
            </p>
            <p className="texto-bola">
              <span className="bold ">Lugares Ocupados:</span>
              <span className="bola-seat ocupado info"></span>
            </p>
          </div>

          <div className="col-lg-9">
            {classDetails.class.type_class === "Train" ? (
              <TrainSeats classDetails={classDetails} handleShow={handleShow} />
            ) : classDetails.class.type_class === "Yoga" || classDetails.class.type_class === "Pilates Mat" || classDetails.class.type_class === "Barre" || classDetails.class.type_class === "Sculpt and Burn" ? (
              <MindBodySeats classDetails={classDetails} handleShow={handleShow} />
            ) : (
              <RideSeats classDetails={classDetails} handleShow={handleShow} />
            )}
          </div>
        </div>
      )}

      <Modal className="modal fade" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmación de lugar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            ¿Esta seguro de reservar el lugar <strong>{seatDetails}</strong>{" "}
            para el día: <strong>{classDetails.class.class_date}</strong> -{" "}
            <strong>{classDetails.class.class_time}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => reservarLugar(seatDetails)}
            disabled={loadingRes}
          >
            Reservar
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={loadingRes}
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Modal membresía usada ────────────────────────────── */}
      <Modal show={membershipModal} onHide={() => { setMembershipModal(false); navigate("/mis-clases"); }} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reservación exitosa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Se utilizó tu <strong>{membershipType}</strong> para esta reservación. ¡Nos vemos en clase!
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => { setMembershipModal(false); navigate("/mis-clases"); }}>
            Ver mis clases
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ── Modal cambio de coach ─────────────────────────────── */}
      <Modal show={showCoachModal} onHide={() => setShowCoachModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cambiar coach</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
            Selecciona el nuevo coach. Se enviará una notificación por correo y en la app a todos los usuarios con reserva.
          </p>
          <select
            className="form-select"
            value={selectedCoachId}
            onChange={(e) => setSelectedCoachId(e.target.value)}
          >
            <option value="">— Selecciona un coach —</option>
            {coaches.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCoachModal(false)}>
            Cancelar
          </Button>
          <Button
            variant="warning"
            disabled={!selectedCoachId || loading}
            onClick={submitCoachChange}
          >
            Cambiar y notificar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DetallesClase;
